import { createFileRoute, redirect } from '@tanstack/react-router'
import { object, optional, parse, string } from 'valibot'
import node, {
  type accountOverviewPageQuery,
} from '#gen/relay/accountOverviewPageQuery.graphql'
import { ErrorHandler } from '#lib/errors/errors'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

const SearchParamsSchema = object({
  filter: optional(string()),
})

export const Route = createFileRoute('/_dashboard/$account/')({
  staticData: { title: 'Home' },
  validateSearch(search) {
    return parse(SearchParamsSchema, search)
  },
  errorComponent: ErrorHandler,
  beforeLoad: () => {
    throw redirect({
      from: '/$account',
      to: '/$account/graphql',
    })

    // if (!Config.IS_ENTERPRISE_BUILD) return

    // if (Config.EP_PRODUCT === 'nexus')
    //   throw redirect({
    //     from: '/$account',
    //     to: '/$account/nexus',
    //   })

    // if (Config.EP_PRODUCT === 'graphql')
    //   throw redirect({
    //     from: '/$account',
    //     to: '/$account/graphql',
    //   })
  },
  loader({ context, params }) {
    return context.preload<accountOverviewPageQuery>(node, {
      ...params,
    })
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/account/account-overview-page'),
    'AccountOverviewPage',
  ),
})
